import * as Store from "../store.js";

export default class ThemeContainer extends React.Component {
    constructor(props) {
        super(props);
        this.theme = Store.getStore("config.theme");
    }
}
